import { PosPlugin } from 'plugins/plugin';
import { getLastProductIndex } from 'reducers/ShoppingCart';

import reduxReducer, {
  removeAllTags,
  removeTagsByProductId,
  updateOrderReturnTags,
} from './redux';
import {
  EnterTagModal,
  RemoveTagModal,
  UICustomTableBillRow,
} from './components';
import { saveReturnTags } from './features/recordReturnTagsData';

const pnpTagOnReturn: PosPlugin = {
  id: 'pnp-tag-returned-products',
  name: 'PnP - Tag returned products',
  info: '# Header',
  // eslint-disable-next-line global-require
  infoMDUrl: require('./Info.md'),
  keywords: ['return', 'pnp', 'tag'],
  reduxReducer,
  getStatus: () => ({ type: 'valid', message: '' }),
  onAddProduct: {
    after: (params, { product }) => async (dispatch, getState) => {
      const orderIndex = getLastProductIndex(getState());

      await dispatch(updateOrderReturnTags({ ...product, orderIndex }));
    },
  },
  onAddMultiProducts: {
    after: (p, orders) => async dispatch => {
      orders.reduce(
        (pr, order) =>
          pr.then(() => {
            dispatch(updateOrderReturnTags(order));
          }),
        Promise.resolve(),
      );
    },
  },
  onUpdateOrderAmount: {
    after: (p, ap) => updateOrderReturnTags(ap),
  },
  onRemoveOrder: {
    after: ({ orderIndex }) => async dispatch => {
      dispatch(removeTagsByProductId(orderIndex));
    },
  },
  onResetShoppingCart: {
    after: () => async dispatch => {
      dispatch(removeAllTags());
    },
  },
  onSaveSalesDocument: {
    on: saveReturnTags,
  },
  components: {
    EnterTagModal,
    RemoveTagModal,
  },
  UICustomTableBillRow,
};

export default pnpTagOnReturn;
